export function getLegacyMotorWindingOperatingTemperatureF(
  motor_od: number,
  motor_length: number,
  motor_catalog_hp: number,
  percent_motor_re_rate: number,
  percent_motor_load: number,
  motor_eff: number,
  pump_eff = 0,
  casing_or_shroud_id: number,
  average_viscosity: number,
  water_cut: number,
  total_flow_rate: number,
  pump_head: number,
  oil_gravity: number,
  water_specific_gravity: number,
  temp_at_setting_depth: number,
  bottom_pump_inlet_density = 0,
  top_pump_discharge_density = 0
): number {
  let water_specific_heat;
  let delta_Tw;

  if (motor_od === 3.19) {
    delta_Tw = 30 * percent_motor_re_rate;
  } else if (motor_od === 3.75) {
    delta_Tw = 40 * percent_motor_re_rate;
  } else if (motor_od === 4.56) {
    delta_Tw = 50 * percent_motor_re_rate;
  } else if (motor_od === 5.62) {
    delta_Tw = 70 * percent_motor_re_rate;
  } else {
    delta_Tw = 100 * percent_motor_re_rate;
  }
  const oil_specific_heat =
    (-1.39 * Math.pow(10, -6) * temp_at_setting_depth +
      1.847 * Math.pow(10, -3)) *
      oil_gravity +
    6.312 * Math.pow(10, -4) * temp_at_setting_depth +
    0.352;
  if (water_specific_gravity <= 1.18) {
    water_specific_heat =
      6.04473357094527 +
      -8.39614729559997 * water_specific_gravity +
      3.3447806736408 * Math.pow(water_specific_gravity, 2);
  } else {
    water_specific_heat =
      6.04473357094527 +
      -8.39614729559997 * 1.18 +
      3.3447806736408 * Math.pow(1.18, 2);
  }

  const average_specific_heat =
    water_specific_heat * water_cut + oil_specific_heat * (1 - water_cut);
  const delta_tf_denominator =
    778 * pump_eff * motor_eff * average_specific_heat;
  const delta_tf = delta_tf_denominator
    ? (pump_head * (1 - motor_eff)) / delta_tf_denominator
    : 0;
  const motor_hp = motor_catalog_hp * percent_motor_re_rate;
  const power_required = motor_hp * percent_motor_load;
  const cross_section_flow_area =
    (Math.PI *
      (Math.pow(casing_or_shroud_id / 12, 2) - Math.pow(motor_od / 12, 2))) /
    4;
  const velocity =
    (total_flow_rate * 0.0000649836034) / cross_section_flow_area;
  const average_sg =
    (bottom_pump_inlet_density + top_pump_discharge_density) / 2 / 64.428;
  const fluid_viscosity = average_viscosity * average_sg * 1.07639104 * 0.00001;
  const k = 0.00001532 * (1 - water_cut) + 0.00005867 * water_cut;
  const h =
    0.0378 *
    Math.pow(k, 0.67) *
    Math.pow(velocity, 0.8) *
    Math.pow(average_sg * 62.428, 0.8) *
    Math.pow(average_specific_heat, 0.33) *
    Math.pow(fluid_viscosity, -0.47) *
    Math.pow(motor_od, -0.2);
  const delta_ts =
    ((2.7 * power_required) / ((motor_length / 12) * motor_od * h)) *
    (1 / motor_eff - 1);
  const tw = temp_at_setting_depth + delta_tf + delta_ts + delta_Tw;
  return tw;
}

export function getLegacyMotorSkinTemperatureF(
  motor_od: number,
  motor_length: number,
  motor_catalog_hp: number,
  percent_motor_re_rate: number,
  percent_motor_load: number,
  motor_eff: number,
  pump_eff = 0,
  casing_or_shroud_id: number,
  average_viscosity: number,
  water_cut: number,
  total_flow_rate: number,
  pump_head: number,
  oil_gravity: number,
  water_specific_gravity: number,
  temp_at_setting_depth: number,
  bottom_pump_inlet_density = 0,
  top_pump_discharge_density = 0
): number {
  let water_specific_heat;
  const average_sg =
    (bottom_pump_inlet_density + top_pump_discharge_density) / 2 / 64.428;
  const fluid_viscosity = average_viscosity * average_sg * 1.07639104 * 0.00001;
  const cross_section_flow_area =
    (3.14159 *
      (Math.pow(casing_or_shroud_id / 12, 2) - Math.pow(motor_od / 12, 2))) /
    4;
  const velocity =
    (total_flow_rate * 0.0000649836034) / cross_section_flow_area;

  if (water_specific_gravity <= 1.18) {
    water_specific_heat =
      6.04473357094527 +
      -8.39614729559997 * water_specific_gravity +
      3.3447806736408 * Math.pow(water_specific_gravity, 2);
  } else {
    water_specific_heat =
      6.04473357094527 +
      -8.39614729559997 * 1.18 +
      3.3447806736408 * Math.pow(1.18, 2);
  }
  const oil_specific_heat =
    (-1.39 * Math.pow(10, -6) * temp_at_setting_depth +
      1.847 * Math.pow(10, -3)) *
      oil_gravity +
    6.312 * Math.pow(10, -4) * temp_at_setting_depth +
    0.352;
  const average_specific_heat =
    water_specific_heat * water_cut + oil_specific_heat * (1 - water_cut);
  const k = 0.00001532 * (1 - water_cut) + 0.00005867 * water_cut;
  const h =
    0.0378 *
    Math.pow(k, 0.67) *
    Math.pow(velocity, 0.8) *
    Math.pow(average_sg * 62.428, 0.8) *
    Math.pow(average_specific_heat, 0.33) *
    Math.pow(fluid_viscosity, -0.47) *
    Math.pow(motor_od, -0.2);
  const delta_tf_denominator =
    778 * pump_eff * motor_eff * average_specific_heat;
  const delta_tf =
    delta_tf_denominator !== 0
      ? (pump_head * (1 - motor_eff)) / delta_tf_denominator
      : 0;
  const motor_hp = motor_catalog_hp * percent_motor_re_rate;
  const power_required = motor_hp * percent_motor_load;
  const delta_ts =
    ((2.7 * power_required) / ((motor_length / 12) * motor_od * h)) *
    (1 / motor_eff - 1);
  const final_calc = delta_ts + delta_tf + temp_at_setting_depth;
  return final_calc;
}
